import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'
import { SiteEditorContextService } from './siteEditorContextService'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(SiteEditorContextService)
}
